import { useFetch } from '../../hooks/useFetch';

export const FetchDashboardSummary = async (params) => {
  const body = await useFetch(`${process.env.REACT_APP_API_URL}/dashboard/summary`, params);

  return body.data;
};
